import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AddToolButton = () => {
  const navigate = useNavigate();
  const [ripple, setRipple] = useState(false);

  const handleClick = () => {
    setRipple(true);
    setTimeout(() => {
      navigate("/user/add-new-tool"); 
    }, 400); 
  };

  return (
    <div className="relative group inline-block">
      {/* دکمه اصلی */}
      <button
        onClick={handleClick}
        onAnimationEnd={() => setRipple(false)}
        className={`relative flex items-center justify-center w-12 h-12 rounded-lg 
        bg-[#1b4747] text-white text-3xl font-bold text-center pt-1
        shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl focus:outline-none overflow-hidden ${
          ripple ? "animate-ripple" : ""
        }`}
      >
        +
      </button>

      {/* تول‌تیپ */}
      <span
        className="absolute left-1/2 -translate-x-1/2 top-full mt-3
        opacity-0 group-hover:opacity-100 transition-opacity duration-300
        bg-gray-900 text-white text-sm rounded-lg px-3 py-1 shadow-lg whitespace-nowrap"
      >
        ابزار جدید
      </span>

      {/* افکت Ripple */}
      <style>{`
        @keyframes rippleEffect {
          0% {
            transform: scale(1);
            opacity: 0.8;
          }
          100% {
            transform: scale(2.5);
            opacity: 0;
          }
        }
        .animate-ripple::after {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: 9999px;
          background: rgba(255, 255, 255, 0.4);
          animation: rippleEffect 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default AddToolButton;
